import { publicBookingEntry } from "../utils/publicBookingEntry";
import { useEffect, useState } from "react";
import {
  ArrowRight,
  Plane,
} from "lucide-react";
import PublicBrandMark from "../components/public/PublicBrandMark";
import heroLandingImage from "../assets/jp-landing-hero-alphard-reference.png";
import kantoAreaImage from "../assets/jp-area-tokyo.png";
import kansaiAreaImage from "../assets/jp-area-osaka.png";
import hokkaidoAreaImage from "../assets/jp-area-hokkaido.png";
import shonanPalmLogo from "../assets/shonan-palm-gold-transparent.png";

const bookingPath = "/book/guest";
const publicBookingEntrySeenKey = "public_booking_entry_seen";
const publicBookingIntroJustSelectedKey = "public_booking_intro_just_selected";
const lineConsultationUrl = "https://line.me/ti/p/cEevGwlVwH";

const priceCards = [
  { route: "東京 → 羽田空港", price: "13,000円〜", tax: "(税込)", vehicle: "Alphard" },
  { route: "東京 → 成田空港", price: "23,000円〜", tax: "(税込)", vehicle: "Alphard" },
];

const languageOptions = [
  { code: "en", label: "EN", path: "/book/guest" },
  { code: "ja", label: "日本語", path: "/book/ja" },
  { code: "zh", label: "中国語", path: "/book/guest" },
  { code: "zhHant", label: "繁体字", path: "/book/guest" },
];

const openingLanguageOptions = [
  { code: "ja", label: "日本語", caption: "日本国内向け予約ページ", path: "/book/ja" },
  { code: "en", label: "English", caption: "Private transfer booking", path: "/book/guest" },
  { code: "zh", label: "简体中文", caption: "机场接送与包车预约", path: "/book/guest" },
  { code: "zhHant", label: "繁體中文", caption: "機場接送與包車預約", path: "/book/guest" },
];

const navItems = [
  { href: "#price", label: "料金目安", index: "01" },
  { href: "#area", label: "対応エリア", index: "02" },
  { href: "#flow", label: "ご利用の流れ", index: "03" },
  { href: lineConsultationUrl, label: "LINE相談", line: true },
];

const mobileNavItems = navItems.filter((item) => !item.line);

function TokyoTowerIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <path d="M24 5.5v37" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" />
      <path d="M16 42.5h16M18.5 5.5h11" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" />
      <path d="M19.5 13.5h9M17.5 22.5h13M15.5 32.5h17" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <path d="M24 5.5 12.5 42.5M24 5.5l11.5 37" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" />
      <path d="M17.5 22.5 24 14l6.5 8.5M15.5 32.5 24 23l8.5 9.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.25 10.2h5.5M20.2 18h7.6M18.8 27.3h10.4" stroke="currentColor" strokeWidth="0.95" strokeLinecap="round" opacity="0.62" />
    </svg>
  );
}

function OsakaCastleIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <path d="M10 42h28" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" />
      <path d="M15.5 42V25.5h17V42" stroke="currentColor" strokeWidth="1.55" strokeLinejoin="round" />
      <path d="M19 25.5v-7h10v7" stroke="currentColor" strokeWidth="1.55" strokeLinejoin="round" />
      <path d="M24 8.5v9.5" stroke="currentColor" strokeWidth="1.55" strokeLinecap="round" />
      <path d="M14 25.5h20l-4.2-5H18.2l-4.2 5Z" stroke="currentColor" strokeWidth="1.45" strokeLinejoin="round" />
      <path d="M17 18.5h14l-3.8-4.5h-6.4L17 18.5Z" stroke="currentColor" strokeWidth="1.45" strokeLinejoin="round" />
      <path d="M20.2 14h7.6l-2.4-3.2h-2.8L20.2 14Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />
      <path d="M13.5 33h21M18.5 29h11M19 37h10" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" opacity="0.72" />
      <path d="M21 32v10M27 32v10" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" opacity="0.62" />
    </svg>
  );
}

function HokkaidoEmblemIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <path d="M24 7v34M7 24h34M12.1 12.1l23.8 23.8M35.9 12.1 12.1 35.9" stroke="currentColor" strokeWidth="1.45" strokeLinecap="round" />
      <path d="m24 7 4.2 7.1H19.8L24 7ZM24 41l-4.2-7.1h8.4L24 41ZM7 24l7.1-4.2v8.4L7 24ZM41 24l-7.1 4.2v-8.4L41 24Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <circle cx="24" cy="24" r="7.2" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="24" cy="24" r="2.2" fill="currentColor" />
    </svg>
  );
}

function DatePlaceIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <rect x="10" y="12.5" width="24" height="22" rx="4" stroke="currentColor" strokeWidth="1.55" />
      <path d="M15.5 9.5v6M28.5 9.5v6M10 19h24" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <path d="M17 24h4M24.5 24h3M17 29h3.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M37.5 28.5c0 4.7-5.5 9.5-5.5 9.5s-5.5-4.8-5.5-9.5a5.5 5.5 0 1 1 11 0Z" stroke="currentColor" strokeWidth="1.45" strokeLinejoin="round" />
      <circle cx="32" cy="28.5" r="1.75" fill="currentColor" />
    </svg>
  );
}

function PriceCheckIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <path d="M13 9.5h18.5l5.5 5.6V39a3.5 3.5 0 0 1-3.5 3.5H13A3.5 3.5 0 0 1 9.5 39V13A3.5 3.5 0 0 1 13 9.5Z" stroke="currentColor" strokeWidth="1.55" strokeLinejoin="round" />
      <path d="M31.5 9.8v5.3H37" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 18.5h10.5M16 34h8.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" opacity="0.72" />
      <path d="M21 24.2h6M24 21.5v12.2M20.7 28.8h6.6" stroke="currentColor" strokeWidth="1.45" strokeLinecap="round" />
      <path d="m29.2 31.6 2.85 2.85 5.85-6.85" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="24" cy="27.5" r="8" stroke="currentColor" strokeWidth="1.05" opacity="0.52" />
    </svg>
  );
}

function SecurePaymentIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <rect x="12" y="6.5" width="19" height="35" rx="4.2" stroke="currentColor" strokeWidth="1.55" />
      <path d="M18.2 11h6.6M19.5 37h4" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" opacity="0.7" />
      <rect x="18" y="18" width="21" height="13.5" rx="3.2" stroke="currentColor" strokeWidth="1.45" />
      <path d="M18 22.4h21M22.5 27.2h5.8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M29.5 18v-2.2a5.1 5.1 0 0 1 10.2 0V18" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <circle cx="35" cy="27" r="1.7" fill="currentColor" />
      <path d="M35 28.4v2.2" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  );
}

function ChauffeurPickupIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <path d="M8.5 31.5h30l-3.6-8.2a4.1 4.1 0 0 0-3.75-2.45h-13.3a4.1 4.1 0 0 0-3.75 2.45L10.5 31.5" stroke="currentColor" strokeWidth="1.55" strokeLinejoin="round" />
      <path d="M12.5 31.5v5.2h5.1l1.45-3.1h10.9l1.45 3.1h5.1v-5.2" stroke="currentColor" strokeWidth="1.55" strokeLinejoin="round" />
      <path d="M16 26.8h17M14.5 33.2h4.5M30 33.2h4.5" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" />
      <circle cx="16" cy="37" r="2.2" fill="currentColor" />
      <circle cx="33" cy="37" r="2.2" fill="currentColor" />
      <path d="M34.2 10.4c2.1 0 3.8 1.7 3.8 3.8s-1.7 3.8-3.8 3.8-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8Z" stroke="currentColor" strokeWidth="1.3" />
      <path d="M30.4 14.1h7.6M32 10.2h4.4" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" />
      <path d="M40 29.3V24a4.6 4.6 0 0 0-4.6-4.6h-2.3" stroke="currentColor" strokeWidth="1.35" strokeLinecap="round" />
      <path d="M39.6 24.6h-5.7v-3.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const areaCards = [
  {
    name: "関東",
    roman: "KANTO",
    image: kantoAreaImage,
    icon: <TokyoTowerIcon className="h-8 w-8" />,
    position: "center 44%",
  },
  {
    name: "関西",
    roman: "KANSAI",
    image: kansaiAreaImage,
    icon: <OsakaCastleIcon className="h-8 w-8" />,
    position: "center 48%",
  },
  {
    name: "北海道",
    roman: "HOKKAIDO",
    image: hokkaidoAreaImage,
    icon: <HokkaidoEmblemIcon className="h-9 w-9" />,
    position: "center 46%",
  },
];

const flowSteps = [
  {
    icon: <DatePlaceIcon className="h-9 w-9" />,
    title: "1. 日時・場所を入力",
  },
  {
    icon: <PriceCheckIcon className="h-9 w-9" />,
    title: "2. 料金を確認",
  },
  {
    icon: <SecurePaymentIcon className="h-9 w-9" />,
    title: "3. オンライン決済",
  },
  {
    icon: <ChauffeurPickupIcon className="h-9 w-9" />,
    title: "4. 当日お迎え",
  },
];

const trustCards = [
  {
    title: "正規ハイヤー会社",
    body: "日本国内で正式に営業許可を受けたハイヤー会社です。",
  },
  {
    title: "事前料金確認",
    body: "ご予約前に料金を確認でき、内容に納得したうえでお申し込みいただけます。",
  },
  {
    title: "オンライン決済",
    body: "クレジットカードで事前決済できます。カード情報は弊社では保存しません。",
  },
  {
    title: "領収書発行対応",
    body: "PDF領収書・適格請求書の発行に対応しています。",
  },
];

const serviceCards = [
  {
    title: "空港送迎",
    body: "羽田空港・成田空港・関西空港・新千歳空港など、空港からホテル・ご自宅までの送迎に対応しています。",
  },
  {
    title: "片道送迎",
    body: "ホテル、駅、レストラン、観光施設、ゴルフ場など、ご指定場所間の送迎に対応しています。",
  },
  {
    title: "貸切チャーター",
    body: "観光、ビジネス、ゴルフ、複数箇所の移動など、時間制の貸切利用に対応しています。",
  },
];

const faqItems = [
  {
    question: "予約前に料金を確認できますか？",
    answer: "はい。ご利用日時、乗車地、目的地、車種などを入力すると、事前に料金をご確認いただけます。弊社は定額運賃でご案内しており、予約確定後に急な追加料金は発生しません。表示料金には車両代・高速道路料金・駐車料金が含まれており、明朗会計の一価全含料金です。",
  },
  {
    question: "料金が表示されない場合はどうすればいいですか？",
    answer: "一部の区間や特殊なご利用内容では、自動で料金が表示されない場合があります。その場合はLINEで個別にご案内いたします。",
  },
  {
    question: "支払い方法は何ですか？",
    answer: "Squareのクレジットカード決済によるオンライン決済に対応しています。カード情報はSquareにより安全に処理され、弊社ではお客様のクレジットカード情報を保存しません。",
  },
  {
    question: "領収書は発行できますか？",
    answer: "はい。PDF領収書・適格請求書の発行に対応しています。",
  },
  {
    question: "対応エリアはどこですか？",
    answer: "関東・関西・北海道に対応しています。その他のエリアについては、現在対応準備中です。",
  },
  {
    question: "空港での待ち合わせはどうなりますか？",
    answer: "空港お迎えでは、ネームボードサービスを標準でご用意しています。ドライバーは到着ロビーでお名前のボードを持ってお待ちします。フライト着陸後90分まで無料でお待ちし、フライト遅延時も追加料金なく対応いたします。フライトが欠航となった場合は、ご予約を無料でキャンセルできます。",
  },
  {
    question: "キャンセル料はかかりますか？",
    answer: "ご利用開始の48時間以内は、原則としてキャンセル・返金を承れません。フライトが欠航となった場合は無料でキャンセルできます。詳しい条件はご予約前の確認画面でご案内します。",
  },
  {
    question: "車種は選べますか？",
    answer: "はい。ご利用人数や荷物数に合わせて、Alphard、HiAce、Premium HiAceからお選びいただけます。荷物が多い場合やゆったり移動したい場合は、HiAceまたはPremium HiAceをおすすめしています。",
  },
];

function setLanguageAndGo(code, path) {
  window.localStorage.setItem(publicBookingEntrySeenKey, "1");
  window.localStorage.setItem("public_booking_lang", code);
  window.location.assign(path);
}

function getPathWithLanguage(path, code) {
  if (path !== "/book/guest") return path;
  return `${path}?lang=${encodeURIComponent(code)}`;
}

function isManualReload() {
  if (typeof window === "undefined" || !window.performance?.getEntriesByType) return false;
  const [navigation] = window.performance.getEntriesByType("navigation");
  return navigation?.type === "reload";
}

function shouldShowOpeningGate() {
  if (typeof window === "undefined") return false;
  if (window.sessionStorage.getItem(publicBookingIntroJustSelectedKey) === "1") {
    window.sessionStorage.removeItem(publicBookingIntroJustSelectedKey);
    return false;
  }
  const params = new URLSearchParams(window.location.search);
  if (params.get("intro") === "1") return true;
  if (window.location.pathname === "/book") return true;
  const introPaths = new Set(["/book", "/book/guest", "/book/member", "/book/ja"]);
  if (!introPaths.has(window.location.pathname)) return false;
  if (window.localStorage.getItem(publicBookingEntrySeenKey) !== "1") return true;
  return isManualReload();
}

function LanguageGlobeIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
      <circle cx="16" cy="16" r="12.25" stroke="currentColor" strokeWidth="1.35" />
      <path
        d="M16 3.75c3.1 3.2 4.65 7.28 4.65 12.25S19.1 25.05 16 28.25C12.9 25.05 11.35 20.98 11.35 16S12.9 6.95 16 3.75Z"
        stroke="currentColor"
        strokeWidth="1.05"
        strokeLinejoin="round"
      />
      <path d="M4.72 12.25h22.56M4.72 19.75h22.56M16 3.75v24.5" stroke="currentColor" strokeWidth="0.95" strokeLinecap="round" opacity="0.84" />
      <path
        d="M8.55 8.65c2.18 1.12 4.66 1.68 7.45 1.68s5.27-.56 7.45-1.68M8.55 23.35c2.18-1.12 4.66-1.68 7.45-1.68s5.27.56 7.45 1.68"
        stroke="currentColor"
        strokeWidth="0.95"
        strokeLinecap="round"
        opacity="0.68"
      />
    </svg>
  );
}

function CustomLanguageDropdown({
  options,
  activeCode = "",
  placeholder = "言語を選択",
  onSelect,
  compact = false,
  align = "right",
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const activeOption = options.find((option) => option.code === activeCode);
  const menuAlignment = align === "left" ? "left-0" : "right-0";

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        className={`group inline-flex w-full items-center justify-between rounded-full border border-[#c8a45d]/38 bg-black/56 text-left text-white shadow-[0_16px_42px_rgba(0,0,0,0.32),inset_0_1px_0_rgba(255,255,255,0.06)] backdrop-blur-xl transition hover:border-[#e8c36e]/72 hover:bg-[#10100c] ${
          compact
            ? "h-9 min-w-[104px] gap-2 px-2.5 text-[11px] font-semibold tracking-[0.04em]"
            : "h-12 gap-3 px-4 text-sm font-semibold tracking-[0.06em]"
        }`}
      >
        <span className="inline-flex min-w-0 items-center gap-2">
          <LanguageGlobeIcon className={compact ? "h-4 w-4 shrink-0 text-[#e8c36e]" : "h-5 w-5 shrink-0 text-[#e8c36e]"} />
          <span className="truncate">{activeOption?.label || placeholder}</span>
        </span>
        <span className={`shrink-0 text-[#d7b76b] transition ${open ? "rotate-180" : ""}`}>⌄</span>
      </button>

      {open && (
        <div
          role="listbox"
          className={`absolute ${menuAlignment} top-[calc(100%+8px)] z-[98] w-full min-w-[184px] overflow-hidden rounded-[14px] border border-[#c8a45d]/42 bg-[#070604]/96 p-1.5 shadow-[0_28px_80px_rgba(0,0,0,0.56),inset_0_1px_0_rgba(255,255,255,0.08)] backdrop-blur-2xl`}
        >
          {options.map((option) => {
            const selected = option.code === activeCode;
            return (
              <button
                key={option.code}
                type="button"
                role="option"
                aria-selected={selected}
                onClick={() => {
                  setOpen(false);
                  onSelect(option);
                }}
                className={`group flex w-full items-center gap-3 rounded-[10px] px-3 py-2.5 text-left transition ${
                  selected
                    ? "bg-[#d7b76b]/16 text-[#f4d98d]"
                    : "text-white/78 hover:bg-white/[0.06] hover:text-white"
                }`}
              >
                <span className={`h-1.5 w-1.5 rounded-full ${selected ? "bg-[#e8c36e]" : "bg-white/24 group-hover:bg-[#d7b76b]/70"}`} />
                <span className="min-w-0">
                  <span className="block text-[13px] font-semibold tracking-[0.05em]">{option.label}</span>
                  {option.caption && (
                    <span className="mt-0.5 block truncate text-[10px] tracking-[0.04em] text-white/42">
                      {option.caption}
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

function scrollToLandingSection(event, href) {
  if (!href?.startsWith("#") || typeof window === "undefined") return;
  const target = document.querySelector(href);
  if (!target) return;
  event.preventDefault();
  const header = window.innerWidth >= 1024
    ? document.querySelector("[data-public-desktop-header]")
    : document.querySelector("[data-public-mobile-header]");
  const headerHeight = header?.getBoundingClientRect?.().height || (window.innerWidth >= 1024 ? 70 : 142);
  const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 22;
  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  window.history.replaceState(null, "", href);
}

function LanguageSwitcher() {
  return (
    <CustomLanguageDropdown
      options={languageOptions}
      activeCode="ja"
      onSelect={(option) => setLanguageAndGo(option.code, option.path)}
      compact
      className="hidden xl:block"
    />
  );
}

function MobileLanguageButton() {
  return (
    <CustomLanguageDropdown
      options={languageOptions}
      activeCode="ja"
      onSelect={(option) => setLanguageAndGo(option.code, option.path)}
      compact
      className="shrink-0"
    />
  );
}

function MobileBrandMark() {
  return (
    <button
      type="button"
      onClick={() => setLanguageAndGo("ja", "/book/ja")}
      className="inline-flex min-w-0 flex-1 items-center gap-2.5 rounded-[16px] border border-[#c8a45d]/20 bg-black/32 px-2.5 py-2 text-left shadow-[0_10px_26px_rgba(0,0,0,0.22)] backdrop-blur-sm"
      aria-label="Shonan International"
    >
      <img
        src={shonanPalmLogo}
        alt=""
        className="h-8 w-8 shrink-0 object-contain drop-shadow-[0_0_18px_rgba(215,183,107,0.58)]"
      />
      <span className="min-w-0">
        <span className="block truncate font-serif text-[11px] font-semibold tracking-[0.12em] text-[#e8c36e]">
          SHONAN INTERNATIONAL
        </span>
        <span className="mt-0.5 block truncate text-[8px] font-semibold tracking-[0.18em] text-white/58">
          Private Transfer & Charter
        </span>
      </span>
    </button>
  );
}

function MobileHeader() {
  return (
    <header data-public-mobile-header className="fixed inset-x-0 top-0 z-40 border-b border-[#c8a45d]/34 bg-black/82 shadow-[0_18px_48px_rgba(0,0,0,0.38)] backdrop-blur-2xl lg:hidden">
      <div className="mx-auto max-w-[620px] px-3.5 py-2.5">
        <div className="flex min-w-0 items-center justify-between gap-3">
          <MobileBrandMark />
          <MobileLanguageButton />
        </div>
        <nav className="mt-2 grid grid-cols-3 gap-1 rounded-full border border-[#c8a45d]/22 bg-black/42 p-1">
          {mobileNavItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(event) => scrollToLandingSection(event, item.href)}
              className="inline-flex h-8 min-w-0 items-center justify-center gap-1 rounded-full px-1.5 text-[10px] font-semibold tracking-[0.02em] text-white/70 transition hover:bg-[#d7b76b]/10 hover:text-[#f2d58d]"
            >
              <span className="font-serif text-[8px] tracking-[0.1em] text-[#d7b76b]/78">{item.index}</span>
              <span className="truncate">{item.label}</span>
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

function LineIcon({ className = "" }) {
  return (
    <span
      className={`inline-flex h-5 w-5 items-center justify-center rounded-[5px] bg-[#06c755] text-white shadow-[0_0_18px_rgba(6,199,85,0.48)] ${className}`}
      aria-hidden="true"
    >
      <svg viewBox="0 0 40 40" className="h-4 w-4" fill="none" aria-hidden="true">
        <path
          d="M20 7.5c-7.7 0-14 4.75-14 10.6 0 5.22 5.05 9.6 11.86 10.42.46.1 1.08.31 1.24.71.14.37.09.95.05 1.33l-.2 1.27c-.06.38-.29 1.44 1.2.78 1.49-.66 8.04-4.72 10.97-8.1 2.02-2.21 3.01-4.47 3.01-6.41C34 12.25 27.72 7.5 20 7.5Z"
          fill="white"
        />
        <path d="M12.8 15.9v5.7h3.4" stroke="#06c755" strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.8 15.9v5.7" stroke="#06c755" strokeWidth="1.45" strokeLinecap="round" />
        <path d="M20.35 21.6v-5.7l3.75 5.7v-5.7" stroke="#06c755" strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M28.7 15.9h-3.1v5.7h3.1M25.6 18.75h2.65" stroke="#06c755" strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

function GoldButton({ children, className = "", compact = false }) {
  return (
    <button
      type="button"
      onClick={() => setLanguageAndGo("ja", bookingPath)}
      className={`group inline-flex items-center justify-center gap-3 rounded-[5px] bg-gradient-to-r from-[#e8c36e] via-[#cfa354] to-[#b78d3f] font-bold tracking-[0.08em] text-black shadow-[0_18px_52px_rgba(201,159,80,0.22)] transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_64px_rgba(201,159,80,0.32)] ${
        compact ? "min-h-[44px] px-5 text-xs" : "min-h-[56px] px-9 text-sm"
      } ${className}`}
    >
      {children}
      <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
    </button>
  );
}

function LineButton({ children, className = "", compact = false }) {
  return (
    <a
      href={lineConsultationUrl}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center justify-center gap-3 rounded-[5px] border border-[#c8a45d]/72 bg-black/46 font-semibold tracking-[0.08em] text-white shadow-[0_14px_42px_rgba(0,0,0,0.3)] transition duration-300 hover:-translate-y-0.5 hover:border-[#06c755]/70 hover:bg-[#06150a] ${
        compact ? "min-h-[40px] px-4 text-xs" : "min-h-[56px] px-8 text-sm"
      } ${className}`}
    >
      <LineIcon />
      {children}
    </a>
  );
}

function PriceCard({ card }) {
  return (
    <article className="group relative overflow-hidden rounded-[9px] border border-[#c8a45d]/62 bg-black/48 px-4 py-3 transition duration-300 hover:-translate-y-0.5 hover:border-[#e8c36e] hover:bg-black/64">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_82%_10%,rgba(200,164,93,0.12),transparent_34%)] opacity-0 transition group-hover:opacity-100" />
      <div className="relative flex items-center gap-4">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#c8a45d]/82 text-[#e8c36e]">
          <Plane className="h-5 w-5" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold tracking-[0.08em] text-white/82 sm:text-sm">{card.route}</p>
          <p className="mt-1.5 flex flex-wrap items-end gap-2 whitespace-nowrap font-serif leading-none tracking-[0.04em] text-[#e8c36e]">
            <span className="text-[clamp(1.45rem,1.85vw,1.95rem)]">{card.price}</span>
            <span className="pb-0.5 text-xs font-semibold tracking-[0.08em] text-[#d7b76b]/84">{card.tax}</span>
          </p>
          <span className="mt-2 inline-flex rounded-full border border-[#c8a45d]/58 px-3 py-0.5 text-[11px] tracking-[0.08em] text-[#d7b76b]">
            {card.vehicle}
          </span>
        </div>
      </div>
    </article>
  );
}

function SectionHeading({ children }) {
  return (
    <div className="mx-auto mb-5 flex max-w-[1268px] items-center gap-5 px-4 sm:px-6 lg:px-8">
      <span className="h-px flex-1 bg-gradient-to-r from-transparent via-[#c8a45d]/70 to-[#c8a45d]/28" />
      <h2 className="font-serif text-xl font-semibold tracking-[0.22em] text-[#e8c36e]">{children}</h2>
      <span className="h-px flex-1 bg-gradient-to-l from-transparent via-[#c8a45d]/70 to-[#c8a45d]/28" />
    </div>
  );
}

export function OpeningLanguageGate() {
  const [phase, setPhase] = useState("intro");
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    // The official site has already selected service and language for this entry.
    if (window.location.pathname === "/book/guest" && publicBookingEntry(window.location.search).service
      && ["en", "ja", "zh", "zhHant"].includes(params.get("lang")) && params.get("intro") !== "1") return true;
    if (shouldShowOpeningGate()) return false;
    return window.localStorage.getItem(publicBookingEntrySeenKey) === "1";
  });
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (dismissed) return undefined;
    if (phase !== "intro") return undefined;
    const timer = window.setTimeout(() => setPhase("language"), 2600);
    return () => window.clearTimeout(timer);
  }, [dismissed, phase]);

  const chooseLanguage = (option) => {
    if (phase === "leaving") return;
    setSelectedOption(option);
    setPhase("leaving");
    window.localStorage.setItem(publicBookingEntrySeenKey, "1");
    window.localStorage.setItem("public_booking_lang", option.code);
    window.setTimeout(() => {
      if (option.code === "ja" && window.location.pathname === "/book/ja") {
        setDismissed(true);
        return;
      }
      window.sessionStorage.setItem(publicBookingIntroJustSelectedKey, "1");
      window.location.assign(getPathWithLanguage(option.path, option.code));
    }, 720);
  };

  if (dismissed) return null;

  const brandLockup = <PublicBrandMark href={null} variant="ceremonial" />;

  return (
    <div className="fixed inset-0 z-[90] overflow-hidden bg-black text-white" style={{ zIndex: 90 }}>
      <style>{`
        @keyframes shonanIntroSweep {
          0% { transform: translateX(-120%); opacity: 0; }
          18% { opacity: 1; }
          100% { transform: translateX(120%); opacity: 0; }
        }
        @keyframes shonanIntroMark {
          0% { opacity: 0; transform: translateY(18px) scale(0.94); filter: blur(10px); }
          42% { opacity: 1; filter: blur(0); }
          100% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
        }
        @keyframes shonanIntroGlow {
          0%, 100% { opacity: 0.32; transform: scale(0.96); }
          50% { opacity: 0.72; transform: scale(1.05); }
        }
        @keyframes shonanLanguageRise {
          0% { opacity: 0; transform: translateY(20px); filter: blur(10px); }
          100% { opacity: 1; transform: translateY(0); filter: blur(0); }
        }
        @keyframes shonanEnterBooking {
          0% { opacity: 0; transform: translateY(18px) scale(0.985); filter: blur(12px); }
          52% { opacity: 1; transform: translateY(0) scale(1); filter: blur(0); }
          100% { opacity: 0; transform: translateY(-14px) scale(1.012); filter: blur(8px); }
        }
        @keyframes shonanEnterVeil {
          0% { opacity: 0; transform: scaleX(0.72); }
          44% { opacity: 0.82; transform: scaleX(1); }
          100% { opacity: 0; transform: scaleX(1.08); }
        }
        .shonan-intro-sweep { animation: shonanIntroSweep 2.2s ease-in-out both; }
        .shonan-intro-mark { animation: shonanIntroMark 1.6s cubic-bezier(.2,.8,.2,1) both; }
        .shonan-intro-glow { animation: shonanIntroGlow 2.4s ease-in-out infinite; }
        .shonan-language-rise { animation: shonanLanguageRise .72s cubic-bezier(.22,.8,.22,1) both; }
        .shonan-enter-booking { animation: shonanEnterBooking .72s cubic-bezier(.22,.8,.22,1) both; }
        .shonan-enter-veil { animation: shonanEnterVeil .72s cubic-bezier(.22,.8,.22,1) both; transform-origin: center; }
      `}</style>
      <img
        src={heroLandingImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-center opacity-42"
      />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_44%,rgba(214,183,106,0.18),transparent_26%),linear-gradient(90deg,rgba(0,0,0,0.94)_0%,rgba(0,0,0,0.72)_44%,rgba(0,0,0,0.86)_100%)]" />
      {phase === "intro" && (
        <div className="absolute inset-x-[12%] top-1/2 h-px bg-gradient-to-r from-transparent via-[#d7b76b]/80 to-transparent shonan-intro-sweep" />
      )}
      {phase === "leaving" && (
        <div className="absolute left-1/2 top-1/2 h-[38vh] w-[min(760px,82vw)] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(215,183,107,0.24)_0%,rgba(215,183,107,0.1)_34%,transparent_72%)] shonan-enter-veil" />
      )}

      <div className="relative flex min-h-screen flex-col items-center justify-center px-5 py-12 text-center">
        <div className="w-full max-w-[620px] rounded-[28px] border border-[#d7b76b]/20 bg-black/42 px-5 py-6 shadow-[0_24px_80px_rgba(0,0,0,0.42)] backdrop-blur-md sm:px-6 sm:py-8 lg:absolute lg:left-1/2 lg:top-1/2 lg:w-full lg:max-w-[620px] lg:-translate-x-1/2 lg:-translate-y-1/2 lg:px-5 lg:py-0 lg:bg-transparent lg:border-0 lg:shadow-none lg:backdrop-blur-0">
          <div className={phase === "intro" ? "shonan-intro-mark" : phase === "leaving" ? "shonan-enter-booking" : ""}>
            {brandLockup}
            {phase === "leaving" && selectedOption && (
              <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#d7b76b]/78">
                {selectedOption.label}
              </p>
            )}
          </div>
        </div>

        {phase === "language" && (
          <div className="mt-10 w-[min(980px,calc(100%-1.5rem))] sm:mt-12 sm:w-[min(980px,calc(100%-2.5rem))] lg:absolute lg:left-1/2 lg:top-[calc(50%+148px)] lg:mt-0 lg:-translate-x-1/2 lg:w-[min(980px,calc(100%-2.5rem))]">
            <div className="mb-3 flex items-center justify-center gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-[#d7b76b]/78 shonan-language-rise sm:mb-5">
              <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#d7b76b]/54" />
              <span>言語を選択</span>
              <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#d7b76b]/54" />
            </div>
            <CustomLanguageDropdown
              options={openingLanguageOptions}
              placeholder="言語を選択"
              onSelect={chooseLanguage}
              align="left"
              className="shonan-language-rise mx-auto w-full max-w-[310px] lg:hidden"
            />
            <div className="hidden w-full grid-cols-2 gap-2.5 shonan-language-rise sm:gap-3 lg:grid lg:grid-cols-4">
            {openingLanguageOptions.map((option) => (
              <button
                key={option.code}
                type="button"
                onClick={() => chooseLanguage(option)}
                className={`group min-h-[92px] rounded-[10px] border px-3 py-3 text-left transition duration-300 hover:-translate-y-1 sm:min-h-[156px] sm:px-5 sm:py-5 ${
                  option.code === "ja"
                    ? "border-[#d7b76b]/78 bg-[#d7b76b]/12 shadow-[0_22px_60px_rgba(215,183,107,0.16)]"
                    : "border-white/14 bg-black/42 hover:border-[#d7b76b]/58 hover:bg-[#d7b76b]/8"
                }`}
              >
                <span className="block font-serif text-base tracking-[0.06em] text-white sm:text-xl sm:tracking-[0.08em]">{option.label}</span>
                <span className="mt-2 block text-[10px] leading-5 tracking-[0.04em] text-white/54 sm:mt-3 sm:text-xs sm:leading-6 sm:tracking-[0.06em]">
                  {option.caption}
                </span>
                <span className="mt-3 inline-flex items-center gap-1.5 text-[10px] font-semibold tracking-[0.1em] text-[#d7b76b] sm:mt-5 sm:gap-2 sm:text-xs sm:tracking-[0.12em]">
                  ENTER
                  <ArrowRight className="h-3 w-3 transition group-hover:translate-x-1 sm:h-3.5 sm:w-3.5" />
                </span>
              </button>
            ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function PublicBookingEntryPage() {
  return (
    <main className="min-h-screen overflow-hidden bg-[#030303] text-white">
      <OpeningLanguageGate />
      <div className="pointer-events-none fixed inset-0 -z-10 bg-[radial-gradient(circle_at_18%_18%,rgba(200,164,93,0.12),transparent_26%),linear-gradient(180deg,#050505_0%,#030303_100%)]" />

      <MobileHeader />

      <header data-public-desktop-header className="fixed inset-x-0 top-0 z-40 hidden border-b border-[#c8a45d]/54 bg-black/90 backdrop-blur-xl lg:block">
        <div className="mx-auto flex h-[70px] max-w-[1500px] items-center justify-between gap-4 px-5">
          <PublicBrandMark onClick={() => setLanguageAndGo("ja", "/book/ja")} />

          <nav className="hidden items-center rounded-full border border-[#c8a45d]/30 bg-black/42 p-1 shadow-[0_18px_55px_rgba(0,0,0,0.38),inset_0_1px_0_rgba(255,255,255,0.06)] backdrop-blur-xl lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(event) => scrollToLandingSection(event, item.href)}
                target={item.line ? "_blank" : undefined}
                rel={item.line ? "noreferrer" : undefined}
                className="group relative inline-flex h-10 items-center gap-2 overflow-hidden rounded-full px-4 text-[12px] font-semibold tracking-[0.08em] text-white/78 transition duration-300 hover:-translate-y-px hover:bg-[#d7b76b]/12 hover:text-[#f2d58d]"
              >
                <span className="pointer-events-none absolute inset-0 opacity-0 transition duration-300 group-hover:opacity-100">
                  <span className="absolute inset-x-3 top-0 h-px bg-gradient-to-r from-transparent via-[#f2d58d]/70 to-transparent" />
                  <span className="absolute inset-x-4 bottom-0 h-px bg-gradient-to-r from-transparent via-[#f2d58d]/34 to-transparent" />
                </span>
                {item.line ? (
                  <LineIcon className="h-4 w-4" />
                ) : (
                  <span className="font-serif text-[10px] tracking-[0.14em] text-[#d7b76b]/72 transition group-hover:text-[#f2d58d]">
                    {item.index}
                  </span>
                )}
                <span className="relative whitespace-nowrap">{item.label}</span>
              </a>
            ))}
          </nav>

          <div className="flex items-center">
            <div className="hidden items-center gap-3 xl:flex">
              <LanguageSwitcher />
              <GoldButton compact>
                料金を確認して予約する
              </GoldButton>
            </div>
            <GoldButton compact className="hidden sm:inline-flex xl:hidden">
              料金を確認して予約する
            </GoldButton>
          </div>
        </div>
      </header>

      <section className="relative min-h-[590px] overflow-hidden pt-[112px] sm:min-h-[610px] lg:min-h-[532px] lg:pt-[70px]">
        <img
          src={heroLandingImage}
          alt="Shonan International Alphard chauffeur"
          className="absolute bottom-0 right-0 top-[70px] hidden h-[calc(100%-70px)] w-[70%] object-cover object-center lg:block"
        />
        <img
          src={heroLandingImage}
          alt=""
          className="absolute inset-0 h-full w-full object-cover object-[58%_50%] lg:hidden"
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.96)_0%,rgba(0,0,0,0.82)_33%,rgba(0,0,0,0.18)_66%,rgba(0,0,0,0.04)_100%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.08)_62%,#030303_100%)]" />

        <div className="relative mx-auto flex min-h-[430px] max-w-[1170px] items-center px-5 py-12 sm:min-h-[450px] sm:px-0 lg:min-h-[462px]">
          <div className="max-w-[680px]">
            <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#d7b76b] sm:text-[13px]">
              Private Chauffeur Service in Japan
            </p>
            <h1 className="font-serif text-[clamp(2.15rem,3.65vw,3.5rem)] font-medium leading-[1.2] tracking-[0.035em] text-white">
              <span className="block sm:whitespace-nowrap">国内での移動を、</span>
              <span className="block sm:whitespace-nowrap">もっと上質に。</span>
            </h1>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <GoldButton className="sm:min-w-[292px]">料金を確認して予約する</GoldButton>
              <LineButton className="sm:min-w-[200px]">LINEで相談する</LineButton>
            </div>
          </div>
        </div>
      </section>

      <section id="price" className="relative z-10 -mt-8 scroll-mt-[172px] px-4 sm:px-6 lg:scroll-mt-[96px] lg:px-8">
        <div className="mx-auto grid max-w-[1120px] gap-4 rounded-[15px] border border-[#c8a45d]/70 bg-black/70 p-3 shadow-[0_30px_90px_rgba(0,0,0,0.52)] backdrop-blur-md lg:grid-cols-[245px_minmax(0,0.76fr)_minmax(0,0.76fr)] lg:items-center">
          <div className="px-1 py-2">
            <p className="flex items-center gap-3 font-serif text-lg font-semibold tracking-[0.12em] text-[#e8c36e]">
              <span className="h-2.5 w-2.5 rotate-45 bg-[#d7b76b]" />
              料金目安
            </p>
            <p className="mt-3 text-xs leading-6 tracking-[0.05em] text-white/62 sm:text-sm">
              <span className="block font-semibold text-white/84">空港送迎の料金目安</span>
              <span className="mt-1 block">表示料金には、高速料金・駐車代・ミーティングサービスがすべて含まれます。</span>
            </p>
          </div>

          {priceCards.map((card) => (
            <PriceCard key={card.route} card={card} />
          ))}

        </div>
      </section>

      <section className="pt-7">
        <SectionHeading>安心ポイント</SectionHeading>
        <div className="mx-auto grid max-w-[1268px] gap-4 px-4 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
          {trustCards.map((card, index) => (
            <article
              key={card.title}
              className="group relative overflow-hidden rounded-[9px] border border-[#c8a45d]/42 bg-black/46 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.28)] transition duration-300 hover:-translate-y-0.5 hover:border-[#d7b76b]/78"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_0%,rgba(215,183,107,0.12),transparent_34%)] opacity-0 transition group-hover:opacity-100" />
              <div className="relative">
                <span className="font-serif text-xs tracking-[0.22em] text-[#d7b76b]/72">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 font-serif text-lg tracking-[0.1em] text-white">{card.title}</h3>
                <p className="mt-3 text-sm leading-7 tracking-[0.04em] text-white/62">{card.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="area" className="scroll-mt-[172px] pt-7 lg:scroll-mt-[96px]">
        <SectionHeading>対応エリア</SectionHeading>
        <div className="mx-auto grid max-w-[1268px] gap-4 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
          {areaCards.map((area) => (
            <article key={area.name} className="group relative aspect-video overflow-hidden rounded-[8px] border border-[#c8a45d]/62 bg-black shadow-[0_18px_52px_rgba(0,0,0,0.28)]">
              <img
                src={area.image}
                alt=""
                className="absolute inset-0 h-full w-full object-cover opacity-78 transition duration-700 group-hover:scale-[1.04]"
                style={{ objectPosition: area.position }}
              />
              <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.82)_0%,rgba(0,0,0,0.5)_44%,rgba(0,0,0,0.12)_100%)]" />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(200,164,93,0.08)_0%,rgba(0,0,0,0)_42%,rgba(0,0,0,0.44)_100%)]" />
              <div className="relative flex h-full items-end px-5 py-4">
                <div className="flex items-center gap-4">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#d7b76b]/78 bg-black/38 text-[#e8c36e] backdrop-blur-sm [&_svg]:h-7 [&_svg]:w-7">
                    <span className="drop-shadow-[0_0_16px_rgba(232,195,110,0.32)]">{area.icon}</span>
                  </span>
                  <div>
                    <p className="font-serif text-xl tracking-[0.18em] text-white sm:text-2xl">{area.name}</p>
                    <p className="mt-0.5 text-[10px] font-bold tracking-[0.34em] text-[#d7b76b]">{area.roman}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="pt-7">
        <SectionHeading>対応サービス</SectionHeading>
        <div className="mx-auto grid max-w-[1268px] gap-4 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
          {serviceCards.map((service) => (
            <article
              key={service.title}
              className="rounded-[9px] border border-[#c8a45d]/42 bg-[linear-gradient(180deg,rgba(255,255,255,0.045),rgba(255,255,255,0.018))] p-5 shadow-[0_20px_60px_rgba(0,0,0,0.24)]"
            >
              <h3 className="font-serif text-xl tracking-[0.12em] text-[#e8c36e]">{service.title}</h3>
              <p className="mt-4 text-sm leading-8 tracking-[0.04em] text-white/66">{service.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="flow" className="scroll-mt-[172px] pt-7 lg:scroll-mt-[96px]">
        <SectionHeading>ご利用の流れ</SectionHeading>
        <div className="mx-auto grid max-w-[1268px] gap-5 px-4 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
          {flowSteps.map((step, index) => (
            <article key={step.title} className="relative rounded-[9px] border border-[#c8a45d]/58 bg-black/58 px-6 py-5 shadow-[0_24px_80px_rgba(0,0,0,0.32)]">
              {index < flowSteps.length - 1 && (
                <ArrowRight className="absolute -right-8 top-1/2 hidden h-7 w-7 -translate-y-1/2 text-[#d7b76b] lg:block" />
              )}
              <div className="flex items-center gap-5">
                <span className="inline-flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-[#d7b76b]/70 text-[#e8c36e]">
                  {step.icon}
                </span>
                  <div>
                  <h3 className="text-base font-semibold tracking-[0.05em] text-white sm:whitespace-nowrap">{step.title}</h3>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="line" className="scroll-mt-[172px] pt-7 lg:scroll-mt-[96px]">
        <div className="mx-auto max-w-[1268px] px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 rounded-[15px] border border-[#c8a45d]/52 bg-black/58 p-5 shadow-[0_30px_90px_rgba(0,0,0,0.34)] md:grid-cols-[1fr_auto] md:items-center md:p-7">
            <div>
              <p className="font-serif text-xl tracking-[0.16em] text-[#e8c36e]">予約前に確認したいことがありますか？</p>
              <p className="mt-4 max-w-3xl text-sm leading-8 tracking-[0.04em] text-white/68">
                車種、荷物の量、チャイルドシート、複数台手配、貸切チャーターの行程など、ご不明点がある場合はLINEでお気軽にご相談ください。料金が自動表示されない場合も、LINEにて個別にご案内いたします。
              </p>
            </div>
            <LineButton compact className="min-w-[180px] justify-self-start md:justify-self-end">
              LINEで相談する
            </LineButton>
          </div>
        </div>
      </section>

      <section id="faq" className="scroll-mt-[172px] pb-20 pt-7 lg:scroll-mt-[96px]">
        <SectionHeading>よくあるご質問</SectionHeading>
        <div className="mx-auto max-w-[1268px] px-4 sm:px-6 lg:px-8">
          <div className="border-y border-[#c8a45d]/36 bg-black/28">
            {faqItems.map((item, index) => (
              <div
                key={item.question}
                className={`grid gap-4 py-5 md:grid-cols-[0.95fr_1.55fr] md:items-start ${
                  index > 0 ? "border-t border-[#c8a45d]/24" : ""
                }`}
              >
                <h3 className="font-serif text-base font-semibold tracking-[0.08em] text-[#e8c36e]">
                  {item.question}
                </h3>
                <p className="text-sm leading-8 tracking-[0.04em] text-white/68">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
